import { combineReducers } from "redux";
import axios from "axios";
import { API } from "../../../../../../const";
import _ from "lodash";
import { Service } from "../../../../../service/service";
import { unAuthorized } from "../../../../../auth/Auth.ducks";
import { fetchKids } from "../../../Kids-list.ducks";
import { fetchOneKid } from "../../../../Kids.ducks";

// REPAS actions

export const POST_REPAS_PENDING = "POST_REPAS_PENDING";
export const POST_REPAS_REJECTED = "POST_REPAS_REJECTED";
export const POST_REPAS_FULFILLED = "POST_REPAS_FULFILLED";

export const GET_REPAS_PENDING = "GET_REPAS_PENDING";
export const GET_REPAS_REJECTED = "GET_REPAS_REJECTED";
export const GET_REPAS_FULFILLED = "GET_REPAS_FULFILLED";

export const GET_REPAS_ALIMENTS_PENDING = "GET_REPAS_ALIMENTS_PENDING";
export const GET_REPAS_ALIMENTS_REJECTED = "GET_REPAS_ALIMENTS_REJECTED";
export const GET_REPAS_ALIMENTS_FULFILLED = "GET_REPAS_ALIMENTS_FULFILLED";

export const PUT_REPAS_PENDING = "PUT_REPAS_PENDING";
export const PUT_REPAS_REJECTED = "PUT_REPAS_REJECTED";
export const PUT_REPAS_FULFILLED = "PUT_REPAS_FULFILLED";

export const DELETE_REPAS_PENDING = "DELETE_REPAS_PENDING";
export const DELETE_REPAS_REJECTED = "DELETE_REPAS_REJECTED";
export const DELETE_REPAS_FULFILLED = "DELETE_REPAS_FULFILLED";

const loading = (state = {}, { type }) => {
  switch (type) {
    case POST_REPAS_PENDING:
    case GET_REPAS_PENDING:
      return true;
    case POST_REPAS_REJECTED:
    case POST_REPAS_FULFILLED:
    case GET_REPAS_REJECTED:
    case GET_REPAS_FULFILLED:
      return false;
    default:
      return false;
  }
};

const error = (state = {}, { type, payload }) => {
  switch (type) {
    case POST_REPAS_PENDING:
    case POST_REPAS_FULFILLED:
    case GET_REPAS_PENDING:
    case GET_REPAS_FULFILLED:
      return null;
    case POST_REPAS_REJECTED:
    case GET_REPAS_REJECTED:
      return payload;
    default:
      return null;
  }
};

const data = (state = {}, { type, payload }) => {
  switch (type) {
    case POST_REPAS_FULFILLED:
    case GET_REPAS_FULFILLED:
      return _.isEmpty(payload.data) ? null : payload.data;
    case POST_REPAS_PENDING:
    case GET_REPAS_PENDING:
      return null;
    case POST_REPAS_REJECTED:
    case GET_REPAS_REJECTED:
      return null;

    default:
      return state;
  }
};

const aliments = (state = {}, { type, payload }) => {
  switch (type) {
    case GET_REPAS_ALIMENTS_FULFILLED:
      return _.isEmpty(payload.data) ? [] : payload.data;
    default:
      return state;
  }
};

// REPAS reducer
export default combineReducers({ loading, error, data, aliments });

export const postRepasMulti = (tok, data) => {
  return (dispatch) => {
    const response = Service.post(
      `${API}api/enfant/creche/enfants/repas`,
      data,
      { headers: { Authorization: `Bearer ${tok}` } }
    );
    response.then((res) => {
      dispatch({ type: POST_REPAS_FULFILLED, payload: res });
      data.idsEnfants.forEach((element) => {
        dispatch(fetchOneKid(tok, element));
      });
    });
    response.catch((err) => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message });
      dispatch({ type: POST_REPAS_REJECTED, payload: err });
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized());
      }
    });
  };
};

export const postRepasSimple = (tok, id, data) => {
  return (dispatch) => {
    const response = Service.post(
      `${API}api/enfant/creche/enfants/${id}/repas`,
      data,
      { headers: { Authorization: `Bearer ${tok}` } }
    );
    response.then((res) => {
      dispatch({ type: POST_REPAS_FULFILLED, payload: res });
      dispatch(fetchOneKid(tok, id));
    });
    response.catch((err) => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message });
      dispatch({ type: POST_REPAS_REJECTED, payload: err });
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized());
      }
    });
  };
};

export const getRepasEvent = (tok, idEvent) => {
  return (dispatch) => {
    const response = Service.get(`${API}api/enfant/creche/repas/${idEvent}`, {
      headers: { Authorization: `Bearer ${tok}` },
    });
    response.then((res) => {
      dispatch({ type: GET_REPAS_FULFILLED, payload: res });
    });
    response.catch((err) => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message });
      dispatch({ type: GET_REPAS_REJECTED, payload: err });
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized());
      }
    });
  };
};

export const updateRepasEvent = (tok, idEvent, data, id) => {
  return (dispatch) => {
    const response = Service.put(
      `${API}api/enfant/creche/repas/${idEvent}`,
      data,
      { headers: { Authorization: `Bearer ${tok}` } }
    );
    response.then((res) => {
      dispatch({ type: PUT_REPAS_FULFILLED, payload: res });
      dispatch(fetchOneKid(tok, id));
    });
    response.catch((err) => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message });
      dispatch({ type: PUT_REPAS_REJECTED, payload: err });
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized());
      }
    });
  };
};

export const deleteRepasEvent = (tok, idEvent, id) => {
  return (dispatch) => {
    const response = Service.deleteOne(
      `${API}api/enfant/creche/repas/${idEvent}`,
      { headers: { Authorization: `Bearer ${tok}` } }
    );
    response.then((res) => {
      dispatch({ type: DELETE_REPAS_FULFILLED, payload: res });
      dispatch(fetchOneKid(tok, id));
    });
    response.catch((err) => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message });
      dispatch({ type: DELETE_REPAS_REJECTED, payload: err });
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized());
      }
    });
  };
};

export const getAllAliments = (tok) => {
  return (dispatch) => {
    const response = Service.get(`${API}api/creche/aliments`, {
      headers: { Authorization: `Bearer ${tok}` },
    });
    response.then((res) => {
      dispatch({ type: GET_REPAS_ALIMENTS_FULFILLED, payload: res });
    });
    response.catch((err) => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message });
      dispatch({ type: GET_REPAS_ALIMENTS_REJECTED, payload: err });
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized());
      }
    });
  };
};
